module.exports = __webpack_public_path__ + "static/assets/84854fe5ed80430214e89ec078e62a7c.svg";